//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Process',
  components: {
    selectMember: function selectMember() {
      return import('@/components/form-common/select-member');
    }
  },
  props: {
    examineData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editUser: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checkedList: [],
      examineList: [],
      examineRules: {},
      index: -1,
      isAppoint: false,
      appointList: [],
      approverDelete: true,
      copyerDelete: true,
      title01: '',
      memberShow: false
    };
  },
  watch: {
    examineData: {
      handler: function handler(nVal) {
        var _this = this;
        this.examineList = nVal.list;
        this.examineRules = nVal.rules;
        this.title01 = '';
        this.$nextTick(function () {
          if (_this.examineRules && _this.examineRules.edit) {
            var editText = '';
            editText = _this.examineRules.edit + '';
            _this.approverDelete = editText.includes('1');
            _this.copyerDelete = editText.includes('2');
            _this.title01 += _this.approverDelete ? '和修改审批人' : '';
            _this.title01 += _this.copyerDelete ? '和删除抄送人' : '';
          }
        });
      },
      immediate: true
    },
    lang: function lang() {
      this.setOptions();
    }
  },
  methods: {
    getExamineText: function getExamineText(id) {
      var str = '';
      if (id == 1) {
        str = '或签';
      } else if (id == 2) {
        str = '会签';
      } else if (id == 3) {
        str = '依次审批';
      }
      return str;
    },
    // 选择成员完成回调
    getSelectList: function getSelectList(data, item) {
      this.checkedList = data;
      item.users = data;
      this.index = -1;
    },
    // 打开选择部门成员
    openDepartment: function openDepartment(row, index) {
      this.index = index;
      row.users.forEach(function (item) {
        item.value = item.id;
      });
      this.$refs.selectMember[index].handlePopoverShow();
    },
    deleteUsersItem: function deleteUsersItem(row, index) {
      row.splice(index, 1);
    },
    judgeNodeText: function judgeNodeText(row) {
      var str = '';
      if (this.approverDelete && row.types === 1 && (row.settype === 2 || row.settype === 7) && row.no_hander === 2 && row.users.length <= 0) {
        str = '直接跳过节点，不视为异常';
      }
      if (this.approverDelete && row.types === 1 && (row.settype === 2 || row.settype === 7) && row.no_hander === 1 && row.users.length <= 0) {
        str = this.examineRules.abnormal <= 0 ? '自动同意' : '转交给指定人员处理';
      }
      return str;
    }
  }
};